export default __webpack_public_path__ + "5a67ae94399d01df367d411085df5310.png";